<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .bold {
    font-weight: 600;
  }

  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    min-width: 0;
    gap: utils.in_rem(8px);
    font-size: 16px;
  }

  .connect-links {
    display: flex;
    flex-direction: row;
    gap: utils.in_rem(12px);
    justify-content: flex-end;
    margin-left: auto;
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";

  export let crms = [];

  const formatCrmNames = (names) => {
    if (names.length === 1) return names[0];
    if (names.length === 2) return `${names[0]} and ${names[1]}`;

    const lastCrm = names.at(-1);
    const otherCrms = names.slice(0, -1).join(", ");
    return `${otherCrms}, and ${lastCrm}`;
  };

  const crmText = () => {
    const isOrAre = crms.length === 1 ? " is" : "s are";
    const crmNames = formatCrmNames(crms.map((crm) => crm.providerTitle));
    return `Your ${crmNames} account${isOrAre} not connected.`;
  };

  const onclick = (crm) => {
    window.location.href =
      crm.link === "/integrations"
        ? `/integrations?provider=${crm.provider}`
        : crm.link;
  };
</script>

<div class="content">
  <span class="bold">{crmText()}</span>
  <span>Connect now to ensure your activity is correctly linked to you.</span>
</div>
<div class="connect-links">
  {#each crms as crm}
    <Button
      leadingIcon="fa-regular fa-link"
      kind="tertiary"
      size="small"
      onclick={() => onclick(crm)}>Connect to {crm.providerTitle}</Button
    >
  {/each}
</div>
